import { AiClient, LinkGenerationPayload } from 'api/clients/AiClient'

export const generateLinks = async ({ payload, signal }: { payload: LinkGenerationPayload; signal?: AbortSignal }) => {
  const linksResponse = await AiClient.generateLinks({ payload, signal })

  if (typeof linksResponse === 'string') {
    return JSON.parse(linksResponse)
  }

  return linksResponse
}
